import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { ESTIMATE_TEMPLATE_CONFIG } from './base/estimate-template-config';

export const estimateTemplateRoutes: Routes = [
  {
    path: ESTIMATE_TEMPLATE_CONFIG.routePath!,
    canActivate: [roleGuard('ADMIN_MASTER')],
    children: [
      {
        path: 'simulator',
        loadComponent: () =>
          import(
            './components/smart/estimate-template-simulator/estimate-template-simulator.component'
          ).then((m) => m.EstimateTemplateSimulatorComponent),
      },
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/estimate-template-list-page/estimate-template-list-page.component'
          ).then((m) => m.EstimateTemplateListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/estimate-template-detail-page/estimate-template-detail-page.component'
              ).then((m) => m.EstimateTemplateDetailPageComponent),
          },
        ],
      },
    ],
  },
];
